<template>
  <div class="offcanvas  offcanvas-end"  id="navbarSupportedContent" ref="navbarSupportedContentDom">
    <div class="offcanvas-header header-height-H5 bg-primary">
      <div class="offcanvas-title text-white title-style" id="offcanvasLabel">微纳制造数字化协同平台</div>
      <button type="button" class="btn-close btn-close-white" @click="h5LeftMenuOpen(false)"></button>
    </div>
    <div class="offcanvas-body">
      <!--          拉开菜单显示-->
      <div class="d-flex flex-column " >
        <div class="fw-bold h6   " >
          系统菜单
        </div>
        <router-link class="nav-item text-black d-block mb-2 w-100 bg-light py-2 px-4 text-start"  active-class="u-link--Active" :to="item.path" v-for="(item,index) in headermenusList" :key="index" @click="h5LeftMenuOpen(false)">
          <a class="nav-link text-start text-black" >{{item.name}}</a>
        </router-link>
        <hr>
        <div class="fw-bold h6" >
          个人中心
        </div>
        <router-link class="nav-item text-black d-block mb-2 w-100 bg-light py-2 px-4 text-start"  active-class="u-link--Active"  :to="item.path" v-for="(item,index) in centermenusList" :key="index" @click="h5LeftMenuOpen(false)">
          <a class="nav-link text-black" >{{item.name}}</a>
        </router-link>
      </div>
      <!--      3个圆心按钮-->
      <div class="d-flex align-items-center justify-content-center my-3">
        <a class="d-flex align-items-center justify-content-center flex-column mx-3" @click="goCompetitionRoom">
          <span class="rounded-circle me-1 p-3" type="submit"  style="background: #536fc4" >
            <i class="bi bi-clock-fill text-white"></i>
          </span>
          <div class=" mt-2">大赛订房</div>
        </a>
        <a class="d-flex align-items-center justify-content-center flex-column mx-3" @click="goEquipment">
          <span class="bg-primary  rounded-circle me-1 p-3" type="submit"  >
            <i class="bi bi-clock-fill text-white"></i>
          </span>
          <div class=" mt-2">预约设备</div>
        </a>
        <a class="d-flex align-items-center justify-content-center flex-column mx-3" @click="openAnnounceAchi">
          <span class="btn-icon1  rounded-circle me-1 p-3" type="submit"  >
            <i class="bi bi-cursor-fill text-white"></i>
          </span>
          <div class=" mt-2">发布成果</div>
        </a>
        <a class="d-flex align-items-center justify-content-center flex-column mx-3" @click="openAnnounceReq">
          <span class="btn-icon2  rounded-circle me-1 p-3" type="submit"  >
            <i class="bi bi-file-earmark-text-fill text-white"></i>
          </span>
          <div class=" mt-2">发布需求</div>
        </a>
      </div>
      <!--      三个按钮-->
      <!--      <div class="d-flex align-items-center my-3">-->
      <!--        <button class="btn btn-sm btn-primary me-1" type="submit" @click="goEquipment">预约设备</button>-->
      <!--        <button class="btn btn-sm btn-icon1 me-1" type="button"  @click="openAnnounceAchi">发布成果</button>-->
      <!--        <button class="btn btn-sm btn-icon2 me-1" type="submit" @click="openAnnounceReq">发布需求</button>-->
      <!--      </div>-->
      <hr class=" mt-4 text-primary" v-if="isLogin">
      <div class="d-flex align-items-center justify-content-center">
        <button type="button" class="btn btn-primary w-50 " v-if="isLogin" @click="loginOut;h5LeftMenuOpen(false)">
          退出登录
        </button>
      </div>
    </div>

  </div>
</template>

<script setup>
import {reactive, onMounted, ref, watch, defineProps, defineEmits, computed} from 'vue'
import {Offcanvas} from 'bootstrap'
import {h5LeftMenuOpen,loginOut} from "@/utils/authCheck"
import {useStore} from 'vuex'
const store = useStore()
let offcanvas;
const navbarSupportedContentDom = ref()
const isLogin = computed(()=>store.state.loginModel.login) // 是否登录
import {centermenusList,headermenusList} from "@/router/menusList"
import router from "@/router";

// 监测登录的模块
watch(() => store.state.manuAction.menuOpen,(now, prev) => {
  h5LeftMenuOpenCtr && h5LeftMenuOpenCtr(now?"open":"close")
},{ deep: true})
// 打开菜单
const h5LeftMenuOpenCtr = (flag)=>{
  if(!offcanvas && navbarSupportedContentDom.value){
    offcanvas = new Offcanvas(navbarSupportedContentDom.value,{backdrop: 'static'})
  }
  if(flag==="open"){
    offcanvas.show()
  }else if(flag==='close'){
    offcanvas.hide()
  }else{
    offcanvas.toggle()
  }
}
// 发布成果
const openAnnounceAchi = ()=>{
  // closeAllModel()
  // showAnnounceAchievementsModel.value = true
  router.push({path:"/supplyadd"})
  h5LeftMenuOpen(false)
}
// 去设备列表
const goEquipment = ()=>{
  router.push("/equipmentsharing")
  h5LeftMenuOpen(false)
}
// 发布需求
const openAnnounceReq = ()=>{
  // closeAllModel()
  // showAnnounceRequirementModel.value = true
  router.push({path:"/demmandadd"})
  h5LeftMenuOpen(false)
}

// 预定大赛房间
const goCompetitionRoom = ()=>{
  router.push({path:"/comroombook"})
  h5LeftMenuOpen(false)
}





onMounted(()=>{



})


</script>

<style scoped lang="scss">
.title-style{
  font-size: 1.2rem;
  font-family: "SansBlack", sans-serif;;
  font-weight: 900;
  letter-spacing:0.8px;
}
.header-height-H5{
  height: 50px;

}
</style>
